import { ChangeDetectorRef, Directive, inject } from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { BoardSourceType } from '@main-application/boards/interfaces/board.enums';

@Directive()
export abstract class KanbanAbstract extends ComponentAbstract {
  protected cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  isLoading = false;
  inspectTurnoverId: number = null;
  BoardSourceType = BoardSourceType;

  protected constructor(..._args: unknown[]) {
    super(..._args);
  }

  toggleLoading(isLoading: boolean) {
    this.isLoading = isLoading;
    this.cdr.detectChanges();
  }
}
